import createPageHeader from '../util/page-header';

import calendar from '../../img/svg/calendar.svg';
import arrowRight from '../../img/svg/arrow-right.svg';

export default function updateLiveTrainingPage() {
    // change 'View course' buttons to 'View'
    let pathCardBtns = document.querySelectorAll('#catalog-courses .coursebox-tags ~ .coursebox-callout');

    for (let btn of pathCardBtns) {
        btn.innerHTML = 'View';
    }

    let searchContainer = document.querySelector('.search-container');

    // inject header
    createPageHeader(
        'Live Training',
        "Register for a live training event to jumpstart your onboarding, see best practices in use, and level up your skills!"
    );

    // inject breadcrumbs
    let mainContainerBreadcrumbs = document.createElement('div');
    mainContainerBreadcrumbs.id='mainContainerBreadcrumbs';
    mainContainerBreadcrumbs.innerHTML = `
        <a href="/">
            Home
        </a>
        <img src="${arrowRight}" alt="right arrow">
        <a href="/page/live-training">
            Live Training
        </a>
    `;

    searchContainer.prepend(mainContainerBreadcrumbs);

    // inject calendar button
    let mainContainerButton = document.createElement('a');
    mainContainerButton.id='mainContainerButton';
    mainContainerButton.classList.add("mainContainerButton");
    mainContainerButton.href = '/calendar';
    mainContainerButton.innerHTML = `
        <img src="${calendar}" alt="calendar icon">
        <span>
            Live training Calendar
        </span>
    `;

    searchContainer.append(mainContainerButton);
};
